import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Divider,
  LinearProgress,Menu,MenuItem,MenuList,
  Modal,Chip,
  Button,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { ArrowUpward, DataSaverOff, MoreVert } from "@mui/icons-material";

const CustomDataCard = ({data,onMenuClick,onDeleteClick,isEditing, status = 'active' }) => {
  const [openModal, setOpenModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
   const [anchorEl, setAnchorEl] = useState(null);


  
console.log("data",data)
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const progressValue =(Number(data.stock_quantity) / (Number(data.salePrice) + Number(data.stock_quantity))) * 100;


   
    const handleNextImage = () => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex < data.images.length - 1 ? prevIndex + 1 : 0
      );
    };
  
    
    const handlePrevImage = () => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : data.images.length - 1
      );
    };

    const StatusStrip = ({ status }) => {
  const isActive = status === 1;

 return (
    <Chip
      label={isActive ? 'Active' : 'Deactivated'}
      size="small"
      Width="100%"
      sx={{
        Width: '100%',
        backgroundColor: isActive ? 'success.main' : 'warning.main',
        color: 'white',
        fontWeight: 600,
        px: 1.5,
        borderRadius: '8px',
        boxShadow: 1,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
      }}
    />
  );
};

  return (
    <>
      {/* Main Card */}
 

{/* {Array.isArray(data) && data.length > 0 ? ( */}
   {/* data.map((item, index) => ( */}
         <Card
           key={data.product_id}
        sx={{
          width: 320,
          height: 420,
          margin: 2,
          borderRadius: 2,
          boxShadow: 3,
          overflow: "hidden",
        }}
      >
    <Box  sx={{ mb: 2, border: '1px solid #ddd', borderRadius: 2, overflow: 'hidden' }}>
      {/* Image section */}
      <Box sx={{ position: "relative", height: 180 }}>
       {data.images.length > 0 ? (
          <CardMedia
            component="img"
            image={data.images[currentImageIndex]?.image_url || ""}
            alt={data.name}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <Typography
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              color: "gray",
              fontStyle: "italic",
            }}
          >
            No image available
          </Typography>
        )}
      
        {/* Navigation buttons */}
        {data.images.length > 1 && (
          <>
            <IconButton
              sx={{ position: "absolute", top: "50%", left: 10, zIndex: 1 }}
              onClick={handlePrevImage}
            >
              {"<"}
            </IconButton>
            <IconButton
              sx={{ position: "absolute", top: "50%", right: 10, zIndex: 1 }}
              onClick={handleNextImage}
            >
              {">"}
            </IconButton>
          </>
        )}

        {/* Menu Button */}
        <IconButton
          sx={{ position: "absolute", top: 5, right: 5, zIndex: 2 }}
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <MoreVertIcon sx={{ cursor: "pointer" }} />
        </IconButton>

        {/* Menu Options */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={() => {
            onMenuClick(data);
            isEditing(true);
          }}>
            <EditIcon fontSize="small" sx={{ marginRight: 1 }} />
            Edit
          </MenuItem>
          <MenuItem onClick={() => onDeleteClick(data.vendor_product_id)} sx={{ display:'none'}}>
            <DeleteIcon fontSize="small" sx={{ marginRight: 1,  }} />
            Delete
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => setAnchorEl(null)} sx={{ display: 'none' }}>
            <DeleteIcon fontSize="small" sx={{ marginRight: 1 }} />
            Cancel
          </MenuItem>
        </Menu>
      </Box>

      {/* Content */}
      <CardContent sx={{ padding: 1 }}>
        <Typography sx={{ fontSize: 20, fontWeight: "bold", marginBottom: 1 }}>
          {data.regularPrice}
        </Typography>

        <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: "bold", marginBottom: 1 }}>
          {data.product_name? data.product_name : data.name}
        </Typography>

        <Typography variant="body2" color="text.secondary"  sx={{
    marginBottom: 2,
    overflow: "hidden", 
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  }}>
          {data.product_description}
        </Typography>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box>
            <Typography variant="body2" color="text.secondary">SKU</Typography>
            <Box sx={{ display: "flex", alignItems: "center", color: "orange" }}>
              <ArrowUpward fontSize="small" />
              <Typography variant="body2" sx={{ marginLeft: 0.5 }}>{data.sku}</Typography>
            </Box>
          </Box>

          <Box>
            <Typography variant="body2" color="text.secondary">Remaining Products</Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <LinearProgress
                variant="determinate"
                value={progressValue}
                sx={{
                  width: 50,
                  height: 8,
                  borderRadius: 5,
                  marginRight: 0.5,
                  bgcolor: "lightgray",
                  "& .MuiLinearProgress-bar": { bgcolor: "#FFA52F" },
                }}
              />
              <Typography variant="body2">
                {Number(data.stock_quantity).toFixed(2)}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
          <StatusStrip status={data.status} />
        </Box>
      </CardContent>
    </Box>
     </Card>
  {/* )) */}
{/* ) : null} */}


     

      {/* Modal */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ marginBottom: 2 }}
          >
            Edit/Delete Options
          </Typography>
          <Typography
            id="modal-description"
            variant="body2"
            color="text.secondary"
            sx={{ marginBottom: 3 }}
          >
            Are you sure you want to perform this action? Please select an
            option below:
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="contained"
              color="primary"
              sx={{ flex: 1, marginRight: 1 }}
              onClick={()=>{}}
            >
              Edit
            </Button>
            <Button
              variant="contained"
              color="error"
              sx={{ flex: 1, marginRight: 1 }}
            >
              Delete
            </Button>
            <Button
              variant="outlined"
              sx={{ flex: 1 }}
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CustomDataCard;
